<template>
  <div class="printing-block-root">
    <div
      v-if="title"
      class="printing-block-title"
    >
      <field
        :label="title"
        type="h3"
      ></field>
    </div>

    <slot />
  </div>
</template>

<script>
import Field from '@/components/printing/field.vue';

export default {
  components: { Field },
  props: { title: { type: String } },
};
</script>

<style lang="scss" scoped>
.printing-block-root {
  margin-bottom: 20px;
}
.printing-block-title {
  margin-bottom: 5px;
}
</style>
